<template>
  <v-app>
    <profile v-model="modals.profile" />

    <v-container v-show="loading">
      <v-layout align-center justify-center row fill-height>
        <v-flex>
          <h1 id="loadingTitle" class="text-xs-center animated infinite pulse">
            {{ $t('panel.loading') }}...
          </h1>
          <v-progress-linear
            color="secondary"
            background-color="primary"
            :indeterminate="true"
          />
        </v-flex>
      </v-layout>
    </v-container>
    <v-card flat v-show="!loading">
      <v-toolbar color="white">
        <v-toolbar-side-icon @click.stop="drawer = !drawer" />
        <v-spacer />
        <router-link to="/sa_home" class="center_logo">
          <img
            id="logo-home"
            max-width="170px"
            :src="require('@/assets/img/0_Skolable.png')"
            href="/sa_home"
          />
        </router-link>
        <v-spacer class="!$vuetify.breakpoint.xsOnly ? 'spacerst' : ''" />
        <v-menu bottom left v-if="!$vuetify.breakpoint.xsOnly">
          <template v-slot:activator="{ on }">
            <v-btn
              class="test"
              v-on="on"
              width="110px"
              plain
              depressed
              color="white"
              :ripple="false"
              id="no-background-hover"
            >
              <v-layout row wrap>
                <v-list-tile>
                  <v-flex xs10 sm10>
                    <v-list-tile-content>
                      <v-list-tile-sub-title
                        style="font-size: 9px; color: #512e6f"
                      >
                        <strong> {{ user.name }}</strong>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-flex>
                  <v-flex xs2 sm2>
                    <v-avatar size="35">
                      <img
                        v-if="user.img != '' && user.img != null"
                        :src="user.img"
                        alt="avatar"
                      />
                      <v-icon v-else color="#512e6f"> account_circle </v-icon>
                    </v-avatar>
                  </v-flex>
                </v-list-tile>
              </v-layout>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile avatar @click="modals.profile = true">
              <v-list-tile-avatar>
                <img
                  v-if="user.img != '' && user.img != null"
                  :src="user.img"
                  alt="avatar"
                />
                <v-icon v-else> account_circle </v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ user.name }} {{ user.lastName }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  Super Administrador
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-action>
                <v-img
                  max-width="40px"
                  :src="
                    require('@/assets/panel/toolbar/SKLB-Cerrar Sesion.png')
                  "
                  alt="activity_centre"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title> Cerrar Sesión </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu bottom left v-else>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-avatar size="35" color="red lighten-4">
                <img
                  v-if="user.img != '' && user.img != null"
                  :src="user.img"
                  alt="avatar"
                />
                <v-icon v-else> account_circle </v-icon>
              </v-avatar>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile avatar @click="modals.profile = true">
              <v-list-tile-avatar>
                <img
                  v-if="user.img != '' && user.img != null"
                  :src="user.img"
                  alt="avatar"
                />
                <v-icon v-else> account_circle </v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ user.name }} {{ user.lastName }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  Super Administrador
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-action>
                <v-img
                  max-width="40px"
                  :src="
                    require('@/assets/panel/toolbar/SKLB-Cerrar Sesion.png')
                  "
                  alt="activity_centre"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title> Cerrar Sesión </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-fade-transition mode="out-in">
        <router-view
          :nUpdateResponse="modals.dResponse"
          @flagUpdate="flags.nUpdate = true"
          @nUpdate="nextRoute"
        />
      </v-fade-transition>
    </v-card>
    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-layout class="items scroll-y scrollDesign" style="min-height: 100vh">
        <v-list class="pt-0" dense style="width: 100%">
          <v-list-tile to="sa_home">
            <v-list-tile-action>
              <v-icon>home</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Consola de Administracion</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="item in menu"
            :key="item.title"
            :to="'/' + lang + '/sa/panel/' + item.route"
            :class="item.isDummy == true ? 'hiddeDummy' : ''"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t(item.name) }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-layout>
    </v-navigation-drawer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import loading from '../Dialogs/Loading2'
import ayuda from './../Dialogs/Ayuda.vue'
import profile from './../Modals/ProfileModalSA.vue'
// import boarding from "../Modals/OnBoarding";
import desition from '../Dialogs/Confirm'
import NewBranch from '../Modals/NewBranch'
import QRview from '../Modals/QRViewPanel'
export default {
  components: {
    ayuda,
    profile,
    // boarding,
    loading,
    NewBranch,
    desition,
    QRview,
  },
  beforeRouteUpdate(to, from, next) {
    // if (from.name == "Levels" && this.flags.nUpdate) {
    //   this.modals.desition = true;
    //   this.route.next = next;
    // } else {
    //   next();
    // }

    next()
  },
  data: () => ({
    drawer: null,
    loading: false,
    alerts: {
      ayuda: false,
    },
    modals: {
      profile: false,
      boarding: false,
      newBranch: false,
      desition: false,
      dResponse: false,
      QRcoll: false,
    },
    qr: '',
    qrimg: '',
    qrname: '',
    user: {},
    flags: {
      loading: false,
      badge: false,
      nUpdate: false,
    },
    brand: {},
    schoolStats: {},
    permits: [],
    lang: 'es',
    route: {
      next: null,
    },
    worshopsModules: [
      {
        nombre: 'Talleres',
        name: 'panel.workshop',
        descriptiion: 'panel.workshopDesc',
        route: 'workshop',
        activo: false,
        icon: 'home_repair_service',
        iconSelected: 'home_repair_service',
        desc: 'Visualiza, administra, descarga y crea nuevos talleres',
        iconImage: 'Workshop.png',
        permit: 'WATCH_VISITS',
      },
      {
        nombre: 'Salones',
        name: 'panel.classroom',
        descriptiion: 'panel.classroomDesc',
        route: 'classroom',
        activo: false,
        icon: 'meeting_room',
        iconSelected: 'meeting_room',
        desc: 'Visualiza, administra, descarga y crea nuevos salones ',
        iconImage: 'Classroom.png',
        permit: 'WATCH_VISITS',
      },
      {
        nombre: 'Días de asueto',
        name: 'panel.holiday',
        descriptiion: 'panel.holidayDesc',
        route: 'holidays',
        activo: false,
        icon: 'celebration',
        iconSelected: 'celebration',
        desc: 'Visualiza, administra, descarga y crea días de asueto ',
        iconImage: 'Holiday.png',
        permit: 'WATCH_VISITS',
      },
    ],
  }),
  watch: {},
  async mounted() {
    this.loading = true
    this.getProfile()
  },
  methods: {
    getProfile() {
      this.$store
        .dispatch('employee/getProfileSA')
        .then((response) => {
          this.loading = false
          this.user = this.getUserSA
          if (
            response.data.imageStorage.miniObjUrl != '' &&
            response.data.imageStorage.miniObjUrl != null
          ) {
            this.user.img = response.data.imageStorage.miniObjUrl
          } else {
            this.user.img = ''
          }
          this.user.name = response.data.firstName
          this.user.lastName = response.data.lastName
          console.log(response)
        })

        .catch((error) => {
          console.log(error)
        })
    },

    logout() {
      this.loading = true
      document.getElementById('loadingTitle').innerHTML = 'Cerrando Sesión'
      var v = this
      this.$forceUpdate()
      setTimeout(function () {
        v.$store
          .dispatch('login/logoutSA')
          .then(() => {
            v.$router.push('/login')
          })
          .catch((error) => {
            v.processErrors(error)
          })
      }, 2000)
    },
    processErrors(error) {
      if (error.response.status == 401) {
        this.$router.push('/login')
      }
    },
    nextRoute() {
      this.flags.nUpdate = false
      this.modals.dResponse = false
      if (this.route.next != null) {
        this.route.next()
      }
    },
  },
  computed: {
    menu() {
      return this.$store.getters.getMenuItems
    },

    //Mappers
    ...mapGetters(['getUser', 'getUserSA']),
  },
}
</script>

<style>
#logo-home {
  width: auto;
  max-width: 170px;
  height: auto;
}

.card--flex-toolbar {
  margin-top: -64px;
}

.items {
  overflow: auto;
  max-height: calc(100vh - 112px);
}

.expandableContainer {
  border-style: solid !important;
  border-color: #e6e6e6 !important;
  border-radius: 15px !important;
  border-width: 2px !important;
}

.spacerst {
  margin-right: -140px;
}
</style>
<style scoped>
@media (min-width: 600px) {
  .center_logo {
    transform: translateX(50%);
  }
}

/* remove this dummy class once the panel reaches 4 cards or more */
.hiddeDummy {
  opacity: 0;
  pointer-events: none;
}

::v-deep .v-dialog--active {
  border-radius: 8px;
}

/deep/ .v-datatable.v-table > thead {
  display: block;
}

/deep/ .v-datatable.v-table > tbody {
  max-height: 40vh;
  min-height: 40vh;
  overflow-y: auto;
  overflow-x: hidden;
  display: block;
  -webkit-overflow-scrolling: touch;
  scrollbar-color: rgba(239, 86, 91, 1) !important;
  scrollbar-color: -moz-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(239, 86, 91, 1)),
    color-stop(100%, rgba(81, 46, 111, 1))
  ) !important;
  scrollbar-color: -webkit-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -o-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -ms-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: linear-gradient(
    to right,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-width: thin;
}

/deep/ #no-background-hover::before {
  background-color: transparent !important;
}
</style>

<style lang="sass">
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css")
</style>
